import React from 'react';

const reviews = [
  {
    name: 'John Smith',
    review: 'Osley & Associates exceeded our expectations. The craftsmanship and attention to detail were outstanding. We love our new home!',
    location: 'Atlanta, GA'
  },
  {
    name: 'Emily Johnson',
    review: 'The team was professional, communicative, and truly cared about our vision. Highly recommend for luxury custom homes.',
    location: 'Roswell, GA'
  },
  {
    name: 'Michael Chen',
    review: 'From start to finish, the process was seamless. The quality and service are unmatched.',
    location: 'Alpharetta, GA'
  }
];

const Reviews = () => {
  return (
    <div className="reviews-page">
      <div className="page-header">
        <div className="container">
          <h1 className="page-title">Client Reviews</h1>
          <p className="page-subtitle">
            Hear what our clients have to say about their experience with Osley & Associates.
          </p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="grid grid-2">
            {reviews.map((review, idx) => (
              <div key={idx} className="review-card">
                <div className="review-content">
                  <p className="review-text">"{review.review}"</p>
                  <div className="review-author">- {review.name}, {review.location}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <style jsx>{`
        .reviews-page {
          padding-top: 80px;
        }
        .page-header {
          background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
          color: var(--white);
          padding: 80px 0;
          text-align: center;
        }
        .page-title {
          font-size: 3rem;
          margin-bottom: 20px;
          font-family: 'Playfair Display', serif;
        }
        .page-subtitle {
          font-size: 1.25rem;
          color: var(--light-blue);
          max-width: 700px;
          margin: 0 auto;
          line-height: 1.6;
        }
        .review-card {
          background: var(--white);
          border-radius: 16px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.08);
          padding: 40px 30px;
          margin-bottom: 30px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
        }
        .review-text {
          font-size: 1.2rem;
          color: var(--text-dark);
          margin-bottom: 18px;
          font-style: italic;
        }
        .review-author {
          color: var(--gold-accent);
          font-weight: 600;
          font-size: 1rem;
        }
        @media (max-width: 768px) {
          .grid-2 {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default Reviews; 